import React, { createContext, useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import isServer from '../utils/isServer';

export const WindowContext = createContext(null);

/**
 * Provider to retrieve the current window, support SSR
 * @param {object}
 */
function WindowProvider({ children }) {
  const [w, setWindow] = useState(null);
  const fromServer = isServer();

  useEffect(() => {
    if (!fromServer) setWindow(isServer() ? null : window);
  }, [fromServer]);

  return <WindowContext.Provider value={w}>{children}</WindowContext.Provider>;
}

WindowProvider.propTypes = {
  children: PropTypes.node.isRequired,
};

export default WindowProvider;
